const prefix = {
  usd: '$',
  eur: '€'
}

const formatMoneyValue = (n, currency, requireCapitalCommitment, blankZero) => {
  if (requireCapitalCommitment === 'blank') {
    return ' '
  }

  currency = !currency ? 'usd' : currency
  const value = n == null ? '' : String(n).trim()
  const compactValue = value.replace(/\s/g, '')
  const numericValue = compactValue.replace(/[$€,]/g, '')
  const numericPattern = /^-?\d+(?:\.\d+)?(?:[MB])?$/
  const zeroPattern = /^-?0(?:\.0+)?$/

  if (!numericPattern.test(numericValue) || (blankZero && zeroPattern.test(numericValue))) {
    return ' '
  }

  return `${prefix[currency]}${compactValue.replace(/[$€]/g, '')}`
}

module.exports = {
  adjustFormatMoney: (n, currency, requireCapitalCommitment) =>
    formatMoneyValue(n, currency, requireCapitalCommitment, false),
  adjustFormatMoneyForPdf: (n, currency, requireCapitalCommitment) =>
    formatMoneyValue(n, currency, requireCapitalCommitment, true),
}
